import {  Modal, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react"
import BenAddressData from "../../Pages/BenAddressData/BenAddressData"

interface BenFilterProps{
    handleCloseModal:any
    companyId?:string
}
export const BenFilterPopup:React.FC<BenFilterProps>=({handleCloseModal,companyId})=>{
    // const { isOpen, onOpen, onClose } = useDisclosure();
    
    return(
        <>
        <Modal size={"xxl"} isOpen={true} onClose={handleCloseModal}>
        <ModalOverlay />
        <ModalContent padding={"1rem"}>
        <ModalCloseButton />
            <ModalHeader>BenFilter</ModalHeader>           
            <BenAddressData companyId={companyId} />     
            {/* <ModalFooter gap={"1rem"}></ModalFooter> */}
        </ModalContent>
        </Modal>
        </>
    )
}